var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"slide-up-down",class:{active: _vm.active}},[_c('div',{staticClass:"slide-up-down__inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }